import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { filter, take } from 'rxjs/operators'
import {
  SelectChannelAccountDialogComponent,
  SelectChannelAccountDialogConfig,
} from '@tv3/containers/channels/channel-connect/dialogs/select-channel-account/select-channel-account-dialog.component'
import { isSomething } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: SharedModule,
})
export class SelectChannelAccountDialogService {
  constructor(private dialog: MatDialog) {}

  public open(config?: SelectChannelAccountDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { config },
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .open(SelectChannelAccountDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(
        take(1),
        filter((res) => isSomething(res))
      )
  }
}
